import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class CustomerSearchResource extends BaseCamelCasedResource {
    pk() {
        return this.customerId || "";
    }
}
CustomerSearchResource.urlRoot = apiResourceUrl("customers");
export { CustomerSearchResource };
class PayoutCustomerSearchResource extends CustomerSearchResource {
}
PayoutCustomerSearchResource.urlRoot = apiResourceUrl("customers/search/payout");
export { PayoutCustomerSearchResource };
class SupplierCustomerSearchResource extends CustomerSearchResource {
}
SupplierCustomerSearchResource.urlRoot = apiResourceUrl("customers/suppliers");
export { SupplierCustomerSearchResource };
//# sourceMappingURL=CustomerSearchResource.js.map